/**
 * groupAccountRelation模块接口列表
 */
import $http from '../utils/http' // 导入http中创建的axios实例

const groupAccountRelation = {
  //根据组ID查询账户
  queryAccountByGroupId (params) {
    return $http.post(`${global.API_URL}/sme/groupAccountRelation/queryAccountByGroupId`, params)
  },
  // 增加
  createAccountRelation (params) {
    return $http.post(`${global.API_URL}/sme/groupAccountRelation/create`, params)
  },
  // 删除
  deleteByGroupIdAndInstanceId (params) {
    return $http.post(`${global.API_URL}/sme/groupAccountRelation/deleteByGroupIdAndInstanceId`, params)
  },
  //查询不存在当前组的账户
  queryAccount(id ,params) {
    let param = new URLSearchParams();
    param.append(id, params);
    return $http.post(`${global.API_URL}/sme/groupAccountRelation/queryAccount`,param);
  },
  // 根据组ID查询账户
  getAccountsByGroupId(id ,params) {
    let param = new URLSearchParams();
    param.append(id, params);
    return $http.post(`${global.API_URL}/sme/groupAccountRelation/getAccountsByGroupId`,param);
  },
  // 查询组管理云平台下所有账号
  getAccountByGroupIdAndCloudPlatform(params) {
    return $http.post(`${global.API_URL}/sme/groupAccountRelation/getAccountByGroupIdAndCloudPlatform`,params);
  }
}

export default groupAccountRelation



// WEBPACK FOOTER //
// ./src/api/groupAccountRelation.js